import React from 'react';
import classNames from 'classnames';
import CitiesListSelectComponent from 'app/components/CitySelect/CitiesListSelectComponent';
import CinemasListSelectComponent from 'app/components/header/CinemasListSelectComponent';
import { Cinema } from 'app/types/common';
interface IProps {
	className?: string;
	isOpen: boolean;
	cinemaSelect?: Cinema['selectButton'] | null;
}

const CitiesListSelectPopup = ({className = '', isOpen, cinemaSelect = null}: IProps) => (
	<div className={classNames('popup__content', className, {'popup__content--open': isOpen})}>
		{cinemaSelect
			? <CinemasListSelectComponent selectButton={cinemaSelect} />
			: <CitiesListSelectComponent />
		}
	</div>
);

export default CitiesListSelectPopup;
